/* Dumont et Co — behaviour ported 1:1 from the original component (state, search rules, sort rules,
   tracking flow). The cart, account and forms now use Shopify instead of local placeholders. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const DATA = JSON.parse(($('#dm-data') || {}).textContent || '{"products":[]}');
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || DATA.root || '/';
  const PRODUCTS = DATA.products.map(p => Object.assign(p, { price: p.p / 100 }));
  const RECENT_KEY = 'placeholder-store-recent-v1';
  const BRAND_URL = { 'Cartier': '/collections/cartier', 'Omega': '/collections/omega', 'Tag Heuer': '/collections/tag-heuer', 'Seiko': '/collections/seiko' };

  // Currency follows the shopper's market (Shopify sets Shopify.currency.active); the cart reply updates it too.
  let CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const money = (n) => {
    if (n == null) return 'Price on request';
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: CUR }).format(Number(n)); }
    catch (e) { return Number(n).toFixed(2) + ' ' + CUR; }
  };
  const curSym = () => { try { return new Intl.NumberFormat('en', { style: 'currency', currency: CUR }).formatToParts(0).find(x => x.type === 'currency').value; } catch (e) { return CUR; } };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const readRecent = () => { try { const r = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(r) ? r : []; } catch (e) { return []; } };
  $$('[data-f-from]').forEach(i => { i.placeholder = curSym() + ' From'; });
  $$('[data-f-to]').forEach(i => { i.placeholder = curSym() + ' To'; });

  /* ---------- overlays (same open/close rules as the original state machine) ---------- */
  const st = { menu: false, cart: false, search: false, closing: false, acct: false, pol: false, sub: false, acc: false };
  const el = {
    menu: $('[data-menu]'), cart: $('[data-cart]'), search: $('[data-search]'), acct: $('[data-acct]'),
    pol: $('[data-pol]'), sub: $('[data-sub]'), acc: $('[data-acc]'), plus: $('[data-plus]')
  };
  let srchT, menuT;
  // Menu fades in and out; it stays in the page until the fade-out (.8s in dumont.css) has finished.
  function showMenu(on) {
    const m = el.menu;
    if (on) { clearTimeout(menuT); m.classList.remove('out'); if (m.hidden) { m.hidden = false; void m.offsetWidth; } m.classList.add('in'); }
    else if (!m.hidden && !m.classList.contains('out')) {
      m.classList.remove('in'); m.classList.add('out');
      menuT = setTimeout(() => { m.hidden = true; m.classList.remove('out'); }, 1200);
    }
  }
  function sync() {
    showMenu(st.menu); el.cart.hidden = !st.cart; el.acct.hidden = !st.acct;
    el.pol.hidden = !st.pol; el.sub.hidden = !st.sub; el.acc.hidden = !st.acc;
    el.plus.setAttribute('opacity', st.acc ? '0' : '1');
    el.search.hidden = !st.search;
    $$('.srchveil, .srchmodal', el.search).forEach(n => { n.classList.toggle('in', !st.closing); n.classList.toggle('out', st.closing); });
  }
  function set(patch) { Object.assign(st, patch); if (patch.search === false) { st.closing = false; clearTimeout(srchT); } sync(); }
  function closeAll() {
    set({ menu: false, cart: false, search: false, acct: false, pol: false, sub: false });
    closePanels();
  }
  function openSearch() {
    set({ search: true, closing: false, menu: false, cart: false, acct: false });
    renderSearch();
  }
  function closeSearch() {
    if (st.closing) return;
    st.closing = true; sync();
    clearTimeout(srchT);
    srchT = setTimeout(() => set({ search: false }), 580);
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-act]');
    if (!t) return;
    const a = t.dataset.act;
    if (t.tagName === 'A') e.preventDefault();
    if (a === 'menu') set({ menu: !st.menu, search: false, cart: false, acct: false });
    else if (a === 'search') openSearch();
    else if (a === 'cart') { set({ cart: true, menu: false, search: false, acct: false }); refreshCart(); }
    else if (a === 'acct') set({ acct: !st.acct, menu: false, search: false, cart: false });
    else if (a === 'close') closeAll();
    else if (a === 'close-search') closeSearch();
    else if (a === 'pol') set({ pol: !st.pol });
    // "Found" doesn't navigate: in the mobile menu it opens the accordion, otherwise the dropdown.
    else if (a === 'found') { if (st.menu) set({ acc: !st.acc }); else set({ sub: !st.sub }); }
    else if (a === 'acc') set({ acc: !st.acc });
    else if (a === 'search-go') runSearch(q.value);
    else if (a === 'clear-recent') { try { localStorage.removeItem(RECENT_KEY); } catch (err) { /* ignore */ } renderSearch(); }
    else if (a === 'checkout') location.href = ROOT + 'checkout';
  });
  // Hover opens the dropdown for mouse users; on touch the tap (click) alone toggles it.
  $$('[data-enter]').forEach(n => n.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') set({ sub: n.dataset.enter === 'found' }); }));
  el.sub.addEventListener('pointerleave', () => set({ sub: false }));
  const hdrEl = $('[data-hdr]');
  hdrEl.addEventListener('pointerover', (e) => { if (e.pointerType === 'mouse' && st.sub && e.target.closest('a, button') && !e.target.closest('[data-enter="found"], [data-sub]')) set({ sub: false }); });
  hdrEl.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && st.sub) set({ sub: false }); });
  const wide = window.matchMedia('(min-width: 750px)');
  const onWide = () => { if (wide.matches && st.menu) set({ menu: false }); };
  if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
  window.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- header: transparent over the home heroes, tone follows the photo behind it ---------- */
  const hdr = $('[data-hdr]');
  if (document.body.hasAttribute('data-home')) {
    let solid = null, tone = null;
    const onScroll = () => {
      const hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hh')) || 56;
      const end = $('[data-hero-end]'), h2 = $('[data-hero2]');
      const y = window.scrollY + hh / 2;
      const s = end ? y > end.getBoundingClientRect().top + window.scrollY : window.scrollY > 8;
      const tn = h2 && y > h2.getBoundingClientRect().top + window.scrollY ? 'dark' : 'light';
      if (s === solid && tn === tone) return;
      solid = s; tone = tn;
      const transparent = !s;
      hdr.style.background = 'transparent';
      hdr.style.color = transparent && tn !== 'dark' ? '#ffffff' : 'var(--ink)';
      hdr.style.borderBottom = '0';
      hdr.classList.toggle('over', transparent); hdr.classList.toggle('solid', !transparent);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- search (same matching and Enter rules as the original) ---------- */
  const q = $('[data-q]');
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[“”"’']/g, '');
  const hay = (p) => norm([p.t, p.c, p.b, p.s, p.x].join(' '));
  const wordsOf = (s) => norm(s).split(/[\s,·\-\/]+/).filter(Boolean);
  const matchAll = (words) => PRODUCTS.filter(p => { const t = hay(p); const tc = t.replace(/[^a-z0-9]/g, ''); return words.every(w => t.includes(w) || tc.includes(w.replace(/[^a-z0-9]/g, ''))); });
  const searchCard = (p) => '<li><a href="' + esc(p.u) + '" style="display:flex;flex-direction:column;gap:12px">' +
    '<span style="position:relative;display:block;aspect-ratio:4 / 5;background:rgba(255,255,255,.05);overflow:hidden">' +
    '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font:600 9px/1 var(--sans);letter-spacing:.13em;text-transform:uppercase;color:rgba(242,239,234,.38)">Image placeholder</span>' +
    (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.c || p.t) + '" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:50% 45%">' : '') +
    '</span><span style="display:flex;flex-direction:column;gap:4px">' +
    '<span style="font:italic 300 12px/1.2 var(--sans);color:#f2efea">' + esc(p.c || p.t) + '</span>' +
    '<span style="font:italic 300 12px/1.2 var(--sans);color:#f2efea">' + money(p.price) + '</span></span></a></li>';
  function renderSearch() {
    const words = wordsOf(q.value.trim().toLowerCase());
    const found = (words.length ? matchAll(words) : PRODUCTS).slice(0, 4);
    $('[data-results]').innerHTML = found.map(searchCard).join('');
    $('[data-search-empty]').hidden = found.length > 0;
    const recent = readRecent().map(h => PRODUCTS.find(p => p.h === h)).filter(Boolean);
    $('[data-recent]').hidden = !recent.length;
    $('[data-recent-list]').innerHTML = recent.map(searchCard).join('');
  }
  // Enter / search icon: a brand name opens that collection; one matching watch opens its page;
  // several matches go to the collection that holds them (or the whole shop).
  function runSearch(raw) {
    const qs = String(raw == null ? '' : raw).trim();
    q.value = qs;
    if (!qs) { location.href = DATA.all; return; }
    const key = qs.toLowerCase().replace(/[^a-z0-9]/g, '');
    const brands = { cartier: 'Cartier', omega: 'Omega', tagheuer: 'Tag Heuer', tag: 'Tag Heuer', heuer: 'Tag Heuer', seiko: 'Seiko' };
    if (brands[key]) { location.href = BRAND_URL[brands[key]]; return; }
    const hits = matchAll(wordsOf(qs));
    if (hits.length === 1) { location.href = hits[0].u; return; }
    if (hits.length > 1) {
      const b = hits[0].b;
      location.href = b && BRAND_URL[b] && hits.every(p => p.b === b) ? BRAND_URL[b] : DATA.all;
    }
    // No match: the panel stays open with "No products match that search."
  }
  q.addEventListener('input', renderSearch);
  q.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); runSearch(q.value); } });
  $('[data-act="search-go"]').addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); runSearch(q.value); } });

  /* ---------- cart drawer on the Shopify cart ---------- */
  const lineHTML = (l) => {
    const img = l.image ? l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    return '<div style="display:flex;gap:16px;align-items:flex-start">' +
      '<span style="position:relative;flex:0 0 auto;width:72px;aspect-ratio:4 / 5;background:rgba(239,231,218,.08);overflow:hidden">' +
      '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font:600 7px/1.2 var(--sans);letter-spacing:.1em;text-transform:uppercase;color:var(--ph);text-align:center">Image</span>' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(l.product_title) + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:50% 45%">' : '') +
      '</span><span style="flex:1;min-width:0;display:flex;flex-direction:column;gap:4px">' +
      '<span style="font:italic 300 12px/1.2 var(--sans);color:#efe7da">' + esc(l.product_title) + '</span>' +
      '<span style="display:flex;align-items:center;gap:8px;margin-top:6px">' +
      '<button data-line="' + esc(l.key) + '" data-qty="' + (l.quantity - 1) + '" aria-label="Decrease" style="width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(239,231,218,.24);background:rgba(239,231,218,.08);color:#efe7da"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1"><path d="M0 4h8"></path></svg></button>' +
      '<span style="min-width:16px;text-align:center;font:italic 400 10px/1 var(--serif);color:#efe7da">' + l.quantity + '</span>' +
      '<button data-line="' + esc(l.key) + '" data-qty="' + (l.quantity + 1) + '" aria-label="Increase" style="width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(239,231,218,.24);background:rgba(239,231,218,.08);color:#efe7da"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1"><path d="M0 4h8M4 0v8"></path></svg></button>' +
      '<button data-line="' + esc(l.key) + '" data-qty="0" style="margin-left:6px;font:italic 400 10px/1.4 var(--serif);color:rgba(239,231,218,.62);text-decoration:underline;text-underline-offset:2px">Remove</button>' +
      '</span></span>' +
      '<span style="flex:0 0 auto;font:italic 300 12px/1.2 var(--sans);color:#efe7da">' + money(l.final_line_price / 100) + '</span></div>';
  };
  function renderCart(c) {
    if (c.currency) CUR = c.currency;
    $('[data-cart-count]').textContent = c.item_count ? String(c.item_count) : '';
    $('[data-cart-empty]').hidden = c.items.length > 0;
    $('[data-cart-filled]').hidden = c.items.length === 0;
    $('[data-cart-lines]').innerHTML = c.items.map(lineHTML).join('');
    $('[data-cart-total]').textContent = money(c.items_subtotal_price / 100);
  }
  const cartReq = (path, body) => fetch(ROOT + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
  function refreshCart() { return cartReq('cart.js').then(r => r.json()).then(renderCart).catch(() => {}); }
  $('[data-cart-lines]').addEventListener('click', (e) => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    cartReq('cart/change.js', { id: b.dataset.line, quantity: Number(b.dataset.qty) }).then(r => r.json()).then(c => { if (c && c.items) renderCart(c); else refreshCart(); }).catch(refreshCart);
  });
  refreshCart();
  if ($('[data-open-cart]')) set({ cart: true });

  /* ---------- product page ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const h = pdp.dataset.handle;
    const recent = [h].concat(readRecent().filter(r => r !== h)).slice(0, 4);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(recent)); } catch (e) { /* ignore */ }

    const add = $('[data-add]');
    add.addEventListener('click', () => {
      cartReq('cart/add.js', { items: [{ id: Number(pdp.dataset.variant), quantity: 1 }] })
        .catch(() => {})
        .then(refreshCart)
        .then(() => set({ cart: true, menu: false, search: false, acct: false }));
    });

    const psl = $('[data-psl]');
    if (psl) {
      const n = $$('li', psl).length;
      let slide = 0;
      const show = () => {
        $('[data-track]', psl).style.transform = 'translateX(-' + (slide * 100) + '%)';
        $('[data-prev]', psl).style.opacity = slide <= 0 ? '0' : '1';
        $('[data-next]', psl).style.opacity = slide >= n - 1 ? '0' : '1';
        $('[data-count]', psl).textContent = (slide + 1) + ' / ' + n;
      };
      $('[data-prev]', psl).addEventListener('click', () => { if (slide > 0) { slide--; show(); } });
      $('[data-next]', psl).addEventListener('click', () => { if (slide < n - 1) { slide++; show(); } });
    }
    const ph = $('[data-ph]');
    if (ph) {
      let slide = 0;
      const show = () => {
        $('[data-ph-label]', ph).textContent = 'product image ' + (slide + 1) + ' of 2 · 4 : 5';
        $$('[data-ph-dot]', ph).forEach((d, i) => { d.style.color = i === slide ? 'var(--ink)' : 'rgba(58,58,58,.4)'; });
      };
      $$('[data-ph-step]', ph).forEach(b => b.addEventListener('click', () => { slide = slide === 0 ? 1 : 0; show(); }));
      $$('[data-ph-dot]', ph).forEach(b => b.addEventListener('click', () => { slide = Number(b.dataset.phDot); show(); }));
    }
  }

  /* ---------- collection toolbar: filters, sort, columns ---------- */
  const coll = $('[data-coll]');
  const panels = coll ? { avail: $('[data-panel="avail"]', coll), price: $('[data-panel="price"]', coll), sort: $('[data-panel="sort"]', coll) } : null;
  function closePanels() { if (panels) Object.values(panels).forEach(p => { p.hidden = true; }); }
  if (coll) {
    const grid = $('[data-grid]', coll);
    const open = (k) => !panels[k].hidden;
    const show = (o) => Object.keys(o).forEach(k => { panels[k].hidden = !o[k]; });
    $$('[data-panel-btn]', coll).forEach(b => b.addEventListener('click', () => {
      const k = b.dataset.panelBtn;
      if (k === 'avail') show({ avail: !open('avail'), price: false, sort: false });
      if (k === 'price') show({ price: !open('price'), avail: false, sort: false });
      if (k === 'sort') show({ sort: !open('sort'), avail: false, price: false });
      if (k === 'filters') { const a = open('avail'); show({ avail: !a, price: !a }); }
    }));
    $$('[data-cols-btn]', coll).forEach(b => b.addEventListener('click', () => {
      grid.dataset.cols = b.dataset.colsBtn;
      $$('[data-cols-btn]', coll).forEach(x => { x.style.borderColor = x === b ? 'var(--ink)' : 'transparent'; });
    }));
    $$('[data-sort]', coll).forEach(b => b.addEventListener('click', () => {
      const s = b.dataset.sort;
      $$('[data-sort]', coll).forEach(x => { x.style.color = x === b ? 'var(--ink)' : 'rgba(58,58,58,.6)'; });
      const items = $$('li[data-i]', grid);
      const i = (li) => Number(li.dataset.i), pr = (li) => Number(li.dataset.price);
      items.sort((a, c) => i(a) - i(c));
      if (s === 'Price, low to high') items.sort((a, c) => pr(a) - pr(c));
      if (s === 'Price, high to low') items.sort((a, c) => pr(c) - pr(a));
      if (s === 'Alphabetically, Z-A') items.reverse();
      items.concat($$('li[data-blank]', grid)).forEach(li => grid.appendChild(li));
      panels.sort.hidden = true;
    }));
    const fin = $('[data-f-in]', coll), fout = $('[data-f-out]', coll), ffrom = $('[data-f-from]', coll), fto = $('[data-f-to]', coll);
    const num = (v) => { const x = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(x) ? null : x * 100; };
    const filter = () => {
      const lo = num(ffrom.value), hi = num(fto.value);
      $$('li[data-i]', grid).forEach(li => {
        const av = li.dataset.avail === '1', p = Number(li.dataset.price);
        let ok = true;
        if (fin.checked !== fout.checked) ok = fin.checked ? av : !av;
        if (lo != null && p < lo) ok = false;
        if (hi != null && p > hi) ok = false;
        li.hidden = !ok;
      });
    };
    [fin, fout].forEach(x => x.addEventListener('change', filter));
    [ffrom, fto].forEach(x => x.addEventListener('input', filter));
  }

  /* ---------- order tracking (original flow; endpoint is a theme setting) ---------- */
  const tf = $('[data-track-form]');
  if (tf) {
    const STAGES = [
      { id: 'confirmed', name: 'Order confirmed', detail: 'Payment successfully received and verified.' },
      { id: 'preparing', name: 'Preparing for dispatch', detail: 'Final checks completed; watch being carefully packed.' },
      { id: 'dispatched', name: 'Dispatched', detail: 'Parcel handed to courier; tracking reference shown.' },
      { id: 'transit', name: 'In transit', detail: 'Latest location/status updates.' },
      { id: 'delivered', name: 'Delivered', detail: 'Confirmed delivery.' }
    ];
    const NOT_FOUND = 'We could not locate that order — please check your details or contact us';
    const THROTTLED = 'Too many attempts — please wait a moment and try again.';
    const endpoint = tf.dataset.endpoint || null;
    const msg = $('[data-track-msg]'), out = $('[data-track-result]'), btn = $('button', tf);
    let busy = false, attempts = [];
    const say = (m) => { msg.textContent = m; msg.hidden = !m; };
    async function fetchOrderStatus(reference, email) {
      if (!endpoint) { console.warn('[tracking] TRACKING_ENDPOINT is not configured — no order lookup was performed.'); return null; }
      const res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ reference: reference, email: email }) });
      if (!res.ok) return null;
      const data = await res.json();
      return data && data.stage ? data : null;
    }
    tf.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (busy) return;
      const reference = $('#trk-ref').value.trim(), email = $('#trk-email').value.trim();
      if (!reference) { out.hidden = true; return say('Please enter your order reference number.'); }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { out.hidden = true; return say('Please enter a valid email address.'); }
      const now = Date.now();
      attempts = attempts.filter(t => now - t < 60000);
      if (attempts.length >= 5) { out.hidden = true; return say(THROTTLED); }
      attempts.push(now);
      busy = true; btn.disabled = true; btn.textContent = 'CHECKING…'; say(''); out.hidden = true;
      let r = null;
      try { r = await fetchOrderStatus(reference, email); } catch (err) { r = null; }
      busy = false; btn.disabled = false; btn.textContent = 'TRACK ORDER';
      if (!r) return say(NOT_FOUND);
      const at = STAGES.findIndex(s => s.id === r.stage);
      out.innerHTML = '<p class="abkicker">ORDER ' + esc(r.reference) + '</p><div style="margin-top:16px">' +
        STAGES.map((s, i) => '<div class="trkstage" data-on="' + (i <= at ? '1' : '0') + '"><span class="trkdot"></span><p class="trkname">' + esc(s.name) + '</p><span></span>' +
          '<p style="font:italic 400 12px/1.7 var(--serif);letter-spacing:.03em;color:var(--body)">' + esc(i === at && r.detail ? r.detail : s.detail) + '</p></div>').join('') + '</div>' +
        (r.courierRef ? '<p style="margin-top:20px">Tracking reference: ' + esc(r.courierRef) + '</p>' : '') +
        (r.location ? '<p>Latest update: ' + esc(r.location) + '</p>' : '');
      out.hidden = false;
    });
  }
})();
